import React, { useState } from 'react';

const contactInfo = [
  {
    c: 'red', label: 'Phone', value: '+977 9849943210', href: 'tel:+9779849943210',
    svg: <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 5.55 5.55l.91-.86a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.02z" stroke="#FF0032" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  },
  {
    c: 'blue', label: 'Email', value: 'chalkandcharter@gmail.com', href: 'mailto:chalkandcharter@gmail.com',
    svg: <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="#0583F2" strokeWidth="1.5"/><polyline points="22,6 12,13 2,6" stroke="#0583F2" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  },
  {
    c: 'red', label: 'Location', value: 'Tripureshwor, Kathmandu', href: null,
    svg: <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" stroke="#FF0032" strokeWidth="1.5"/><circle cx="12" cy="10" r="3" stroke="#FF0032" strokeWidth="1.5"/></svg>,
  },
];

export default function Contact() {
  const [form, setForm] = useState({ name:'', phone:'', email:'', message:'' });
  const [sent, setSent]  = useState(false);

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  const submit = e => { e.preventDefault(); setSent(true); };

  return (
    <section id="contact" className="section bg-surface">
      <div className="max-w-content mx-auto">

        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16 reveal">
          <span className="label label-red">Contact</span>
          <h2 className="heading mt-5">Let's Start Your<br /><em>Campus Campaign</em></h2>
          <div className="divider center wide mt-5 mb-5" />
          <p className="subtext text-base">
            Ready to connect with educational institutions? Fill out the form and our
            team will get back to you within 24 hours.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10">

          {/* Left — contact info */}
          <div className="lg:col-span-2 flex flex-col gap-5">
            {contactInfo.map((info, i) => (
              <div key={info.label}
                className={`card reveal-l d${i+1} ${info.c === 'red' ? 'accent-red red-hover' : 'accent-blue blue-hover'} p-6 flex items-center gap-5`}>
                <div className={`icon-box ${info.c} shrink-0`}>{info.svg}</div>
                <div>
                  <p className="text-white/38 text-xs font-bold uppercase tracking-widest mb-1">{info.label}</p>
                  {info.href
                    ? <a href={info.href} className="text-white font-semibold text-sm hover:opacity-80 transition-opacity">{info.value}</a>
                    : <p className="text-white font-semibold text-sm">{info.value}</p>
                  }
                </div>
              </div>
            ))}

            {/* Social links */}
            <div className="card reveal-l d4 p-6" style={{ borderColor:'rgba(255,255,255,.06)' }}>
              <p className="text-white/38 text-xs font-bold uppercase tracking-widest mb-4">Follow Us</p>
              <div className="flex gap-3">
                <a href="https://www.facebook.com/profile.php?id=61584959453443"
                  target="_blank" rel="noopener noreferrer"
                  className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-white/60 hover:text-white transition-colors text-xs font-bold"
                  style={{ background:'rgba(255,255,255,.05)', border:'1px solid rgba(255,255,255,.08)' }}>
                  Facebook
                </a>
                <a href="https://www.linkedin.com/company/chalkandcharter/"
                  target="_blank" rel="noopener noreferrer"
                  className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-white/60 hover:text-white transition-colors text-xs font-bold"
                  style={{ background:'rgba(255,255,255,.05)', border:'1px solid rgba(255,255,255,.08)' }}>
                  LinkedIn
                </a>
              </div>
            </div>
          </div>

          {/* Right — form */}
          <div className="lg:col-span-3 reveal-r">
            <div className="card accent-red p-8 md:p-10" style={{ borderColor:'rgba(255,0,50,.18)' }}>
              {sent ? (
                <div className="text-center py-14">
                  <div className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-6"
                    style={{ background:'rgba(255,0,50,.12)', border:'1.5px solid rgba(255,0,50,.3)' }}>
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                      <polyline points="20 6 9 17 4 12" stroke="#FF0032" strokeWidth="2.5" strokeLinecap="round"/>
                    </svg>
                  </div>
                  <h3 className="text-white font-bold text-xl mb-2">Message Sent!</h3>
                  <p className="subtext text-sm">We'll get back to you within 24 hours.</p>
                  <button onClick={() => setSent(false)}
                    className="mt-6 text-white/40 hover:text-white text-xs transition-colors underline underline-offset-2">
                    Send another message
                  </button>
                </div>
              ) : (
                <form onSubmit={submit} className="flex flex-col gap-5">
                  <div>
                    <h3 className="text-white font-bold text-lg mb-1">Send us a message</h3>
                    <p className="text-white/38 text-sm">We read every message personally.</p>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="text-white/40 text-xs font-bold uppercase tracking-widest block mb-2">Full Name *</label>
                      <input name="name" value={form.name} onChange={handle} required
                        placeholder="Your name" className="form-input" />
                    </div>
                    <div>
                      <label className="text-white/40 text-xs font-bold uppercase tracking-widest block mb-2">Phone</label>
                      <input name="phone" value={form.phone} onChange={handle}
                        placeholder="+977 98XXXXXXXX" className="form-input" />
                    </div>
                  </div>
                  <div>
                    <label className="text-white/40 text-xs font-bold uppercase tracking-widest block mb-2">Email Address *</label>
                    <input name="email" type="email" value={form.email} onChange={handle} required
                      placeholder="your@email.com" className="form-input" />
                  </div>
                  <div>
                    <label className="text-white/40 text-xs font-bold uppercase tracking-widest block mb-2">Message *</label>
                    <textarea name="message" value={form.message} onChange={handle} required rows={5}
                      placeholder="Tell us about your campaign goals, budget, and timeline..."
                      className="form-input resize-none" />
                  </div>
                  <button type="submit" className="btn-red justify-center text-base py-4">
                    Send Message
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M22 2L11 13M22 2L15 22l-4-9-9-4 20-7z" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                  </button>
                </form>
              )}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
